module.exports = __webpack_public_path__ + "static/media/date-icon.7026ddbc.svg";